import Vue from 'vue'
import App from './App.vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import {post,get,upload} from "./http"
import store from './store'
import {timeFromNow,handleDate} from './dependences/moment.js'
import VuevideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import './wxShare';
import VueLazyload from 'vue-lazyload';
import Debounce from './fangdou.js'
require('vue-video-player/src/custom-theme.css')

console.log(Vue.prototype)
Vue.prototype.Debounce=Debounce
Vue.prototype.timeFromNow=timeFromNow
Vue.prototype.handleDate=handleDate
Vue.prototype.post=post
Vue.prototype.get=get
Vue.prototype.upload=upload 

Vue.config.productionTip = false


Vue.use(VueLazyload)
Vue.use(VuevideoPlayer);
Vue.use(Element)
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

